export default {
  updateExample: (state, data) => state.example = data
}